// extracted by mini-css-extract-plugin
export var description = "Card-module--description--a8eca";
export var details = "Card-module--details--ca5be";
export var expand = "Card-module--expand--a85f8";
export var fadeText = "Card-module--fadeText--bedd5";
export var filterHeading = "Card-module--filterHeading--e0334";
export var filteredResults = "Card-module--filteredResults--8fff5";
export var filteredVideo = "Card-module--filteredVideo--08eae";
export var growSpacer = "Card-module--growSpacer--da0aa";
export var icon = "Card-module--icon--87de7";
export var image = "Card-module--image--3afe4";
export var left = "Card-module--left--bb3f6";
export var numVideos = "Card-module--numVideos--dfe48";
export var picture = "Card-module--picture--fa7e5";
export var playIcon = "Card-module--playIcon--87823";
export var red = "Card-module--red--e6cc3";
export var right = "Card-module--right--7f62c";
export var root = "Card-module--root--4cc83";
export var slim = "Card-module--slim--251ef";
export var smallTitle = "Card-module--smallTitle--bb814";
export var spacer = "Card-module--spacer--eced0";
export var tags = "Card-module--tags--08e5f";
export var text = "Card-module--text--e112a";
export var title = "Card-module--title--5624d";
export var trackType = "Card-module--trackType--2fd60";